// src/services/toast.js
const listeners = new Set();

export function onToast(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function toast({ title, body, variant = null, delay = 3000 }) {
  listeners.forEach((fn) => fn({ title, body, variant, delay }));
}
